// extracted by mini-css-extract-plugin
module.exports = {"header":"PartnersPackages_header__3kYN7"};